import { render, staticRenderFns } from "./CRTab.vue?vue&type=template&id=2556a82a&scoped=true"
import script from "./CRTab.vue?vue&type=script&lang=js"
export * from "./CRTab.vue?vue&type=script&lang=js"
import style0 from "./CRTab.vue?vue&type=style&index=0&id=2556a82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2556a82a",
  null
  
)

export default component.exports